import MidiEffect from './MidiEffect';
class MidiRandom extends MidiEffect {
    constructor() {
        super(...arguments);
        this.chance = 0;
        this.choices = 12;
        // there are the currently playing voices by output pitch
        // the element's content is the pitch of the note which triggered the output note
        this.playingNotes = [];
    }
    triggerAttack(note, time, velocity) {
        const randomPitch = note + Math.ceil(Math.random() * this.choices);
        const shouldUseRandomPitch = Math.random() < this.chance;
        const newPitch = shouldUseRandomPitch ? randomPitch : note;
        this.playingNotes[newPitch] = note;
        this.output().triggerAttack(newPitch, time, velocity);
    }
    triggerRelease(time, note) {
        const outputedNote = this.playingNotes.indexOf(note);
        this.playingNotes[outputedNote] = null;
        this.output().triggerRelease(time, outputedNote);
    }
}
export default MidiRandom;
//# sourceMappingURL=MidiRandom.js.map